export default __webpack_public_path__ + "static/media/help-desk-4.c763ce53.png";